import { Component } from '@angular/core';

@Component({
  selector: 'app-gallary-of-image',
  templateUrl: './gallary-of-image.component.html',
  styleUrls: ['./gallary-of-image.component.css']
})
export class GallaryOfImageComponent {

}
